import { container } from "inversify-props";
import IAppConfigService, { AppConfigService } from "@/core/services/AppConfigService";

/**
 * Core Dependency Injection
 * Do no modify. For Application specific DI use @/app/app-container.ts
 */
export function coreContainerBuilder(): void {
  container.addSingleton<IAppConfigService>(AppConfigService);
}
